import Settings from "../../components/settings.json";
import axios from "axios";
import config from "../../config/config";

export const loginAction = (credentials) => {
  return (dispatch) => {
    axios
      .post(`${config.BASE_URL}${Settings.loginAPI}`, credentials)
      .then((res) => {
        dispatch({
          type: "LOGIN_ACTION_SUCCESS",
          userDetails: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: "LOGIN_ACTION_ERROR",
        });
      });
  };
};
